<template>
  <div>
    <ion-img class="img" src="/assets/image/hear-1.png"></ion-img>
  </div>
</template>

<script>
import {IonImg} from "@ionic/vue";

export default {
  name: "TestHearStart",
  components: {
    IonImg
  }
}
</script>

<style scoped>

</style>